import { Route } from "react-router-dom";
import CustomerPanelIndex from "./AdminIndex";
import AddOrUpdateStore from "./Store/Components/AddOrUpdate/AddOrUpdateIndex";
import Payment from "./Ad/Components/Payment/Payment";
import ContractPaymentDescription from "./Ad/Components/Payment/ContractPaymentDescription";
import AddOrUpdateContractIndex from "./Contract/Components/AddOrUpdate/AddOrUpdateContractIndex";
import DopingListItem from "./Ad/Components/Doping/Components/DopingListItem";
import PackageListItem from "./Ad/Components/Doping/Components/PackgaeListItem";




export const customerPanelRouteList = [
  <Route key={"customerPanelRouteList"}>
      <Route path="/admin/panel" element={<CustomerPanelIndex />} />
      <Route path="/admin/panel/add/store" element={<AddOrUpdateStore />} />
      <Route path="/admin/panel/sozlesme-ekle-guncelle" element={<AddOrUpdateContractIndex />} />
    
      <Route path="/payment" element={<Payment/>} />
      <Route path="/sozlesme/odeme" element={<ContractPaymentDescription/>} />
      <Route path="/doping-satin-al" element={<PackageListItem/>} />
     
  </Route>,
];
